import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { procurementApi } from '../../api/procurement';

export function RFQManagerPage() {
  const [rfqs, setRfqs] = useState<unknown[]>([]);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    void procurementApi.listRFQs().then(setRfqs);
  }, []);

  async function createRFQ() {
    const deadline = new Date(Date.now() + 7 * 86400000).toISOString();
    await procurementApi.createRFQ({
      title: 'Q1 component sourcing',
      vendor_ids: ['vendor-a', 'vendor-b'],
      deadline,
      items: [{ sku: 'SKU-001', quantity: 500, unit_price: 0 }],
    });
    setMsg('RFQ issued');
    setRfqs(await procurementApi.listRFQs());
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/procurement" className="text-sm text-slate-600 hover:underline">← Procurement hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">RFQ manager</h1>
      {msg && <p className="mt-2 text-sm text-green-700">{msg}</p>}
      <button type="button" onClick={() => void createRFQ()}
        className="mt-4 rounded-lg bg-slate-900 px-4 py-2 text-sm text-white">Issue RFQ</button>
      <pre className="mt-6 overflow-auto rounded border p-3 text-xs">{JSON.stringify(rfqs, null, 2)}</pre>
    </div>
  );
}
